import { FC } from 'react';

import { ProgressBarSectionContent } from 'models/progressBar/progressBarSectionContent.model';

import { IconMetavrseLogo } from 'icons';

import Body2 from 'common/Body2/Body2';

import classes from './ProgressBar.module.css';

type Props = {
  section: ProgressBarSectionContent;
};

const ProgressBar: FC<Props> = ({ section }) => {
  const { content, innerSectionProgressValue, finishedSectionProgress } =
    section;

  const innerProgress = innerSectionProgressValue as number;

  return (
    <div className={classes.root}>
      <div>
        <IconMetavrseLogo
          color="var(--primaryVariant)"
          svgElementProps={{ width: 60 }}
        />
      </div>
      <div className={classes.progressBar}>
        <div className={classes.content}>
          <div className={classes.contentText}>
            <Body2 ellipsis>{content}</Body2>
          </div>
          <div className={classes.progressValue}>
            <Body2>
              {innerProgress >= 0 ? innerProgress : finishedSectionProgress}%
            </Body2>
          </div>
        </div>

        <div className={classes.progressBarInner}>
          <div
            className={classes.progressBarTotal}
            style={{
              width: `${
                innerProgress >= 0 ? innerProgress : finishedSectionProgress
              }%`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
